import { type ApiService } from '../types/ApiService';

export const facility = (centralApi: ApiService) => ({
  putTextingLocalStatus: (status) => {
    return centralApi.put('/facility', { textingLocalStatus: status });
  },
  putCommunicationsEnabled: (enabled: boolean) => {
    return centralApi.put('/facility', { communicationsEnabled: enabled });
  },
  putAudioCallEnabled: (enabled: boolean) => {
    return centralApi.put('/facility', { audioCallingEnabled: enabled });
  },
  putVideoCallEnabled: (enabled: boolean) => {
    return centralApi.put('/facility', { videoCallingEnabled: enabled });
  },
  putMusicEnabled: (enabled: boolean) => {
    return centralApi.put('/facility', { musicEnabled: enabled });
  },
  putReferenceMaterialEnabled: (enabled: boolean) => {
    return centralApi.put('/facility', { referenceMaterialEnabled: enabled });
  },
});
